import App from "@frog/source/models/App.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"
import World from "@frog/source/models/World.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"
import Objdict from "objdict"

export default {
    "slug": "1",
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
            "width": 30,
            "height": 30,
        }),
        "configuration": {
            "hasColoredBorders": true
        },
        "hud": require("./hud.jsx").default,
        "scripts": [
            {
                "trigger": "turn:0:start",
                "events": [
                    PlotSteps.ReportStartingAnalytics(),
                    Step.flag("hud", "hidden"),
                    Step.flag("Cutscene", true),
                    Step.deltastage({"unit": {"key": "priest", "weaponImageKey": "hidden"}}),
                    Step.deltastage({"unit": {"key": "professor", "weaponImageKey": "hidden"}}),
                    Step.deltastage({"unit": {"key": "occultist", "weaponImageKey": "hidden"}}),
                    PlotSteps.KillAudio("music"),
                    PlotSteps.PlayAudio("Ambience"),

                    PlotSteps.BlackoutDialogue(`
                        In these darkest of woods, this most stormy of nights
                        Three guests enter to my abode
                        Perhaps they seek shelter, away from the rain,
                        Perhaps they seek rest from the road
                    `),

                    PlotSteps.BlackoutDialogue(`
                        Perhaps I shall host a luxurious feast,
                        To their glorious health we shall toast
                        How fortuitous that they shall soon want for nothing,
                        For I am the most gracious of hosts
                    `),

                    Step.flag("modal", null),
                    PlotSteps.PlayAudio("Music:Opening"),
                    PlotSteps.ChapterStart([
                        "You are cordially invited",
                        "to tonight's banquet",
                        "In Which",
                        "Our Most Gracious Host",
                        "will greet you with utmost hospitality"
                    ]),
                    () => {App.unskippable = true},
                    "PROFESSOR: It seems our host has yet to arrive.",
                    "PROFESSOR: ...I’m no superstitious type, but does this manor not strike you as odd?",
                    "PROFESSOR: We’ve been invited to a feast, yet I spied no kitchens in my walkabout of the place.",
                    "OCCULTIST: Oh, but our host has been most hospitable!",
                    "OCCULTIST: And I do so love the decor~! A touch of red never harmed anyone.",
                    "PRIEST: A thorough dousing of red, more like... #position:4",
                    "PRIEST: Nothing about this p-place sits right with me. I think we should- #position:4",
                    PlotSteps.Wait(100),
                    Step.deltastage({
                        "unit": {
                            "key": "artist",
                            "isRemoved": false,
                            "maxhealth": 40,
                            "affiliation": "good",
                        }
                    }),
                    "ARTIST: Ah, lovely! It seems you are all assembled. #position:4",
                    "ARTIST: Welcome, dearest guests, to the feast! I am sure this shall be a most delicious night for us all. #position:4",
                    "OCCULTIST: Oh my, how exciting!",
                    "PROFESSOR: Too exciting, perhaps...",
                    "PRIEST: Ah, the hour is rather late... P-perhaps we should... take our leave? #position:4",
                    PlotSteps.PlayAudio("Tension:Opening"),
                    Step.deltastage({"camera": {"unitKey": "monster1"}}),
                    "ARTIST: Leaving so soon? You wound me. #position: 4",
                    Step.deltastage({"unit": {"key": "artist", "imageKey": "monster-host-smile"}}),
                    "ARTIST: After all, what is a feast without the main course? #position: 4 #expression: smile",
                    PlotSteps.Wait(1000),
                    Step.deltastage({"unit": {"key": "monster1", "isRemoved": false}}),
                    Step.deltastage({"unit": {"key": "monster2", "isRemoved": false}}),
                    Step.deltastage({"unit": {"key": "priest", "weaponImageKey": "horror-crucifix"}}),
                    Step.deltastage({"unit": {"key": "professor", "weaponImageKey": "horror-gun"}}),
                    Step.deltastage({"unit": {"key": "occultist", "weaponImageKey": "horror-knife"}}),
                    PlotSteps.PlayStinger("Scream"),
                    PlotSteps.PlayAudio("Music:Combat:1"),
                    PlotSteps.Wait(500),
                    // "SCREEEEEEEEE",
                    "PRIEST: ???",
                    "PROFESSOR: ???",
                    "OCCULTIST: !!!",
                    Step.deltastage({
                        "unit": {
                            "key": "artist",
                            "imageKey": null,
                            "affiliation": "bad",
                            "health": 70,
                            "maxhealth": 70,
                            "position": {
                                "x": 15,
                                "y": 22,
                                "z": 1
                            },
                        }
                    }),
                    Step.flag("Cutscene", false),
                    Step.flag("hud", null),
                    Step.deltastage({"camera": {"unitKey": null}}),
                    () => {App.unskippable = false},
                ]
            },
            // {
            //     "trigger": "turn:every-even:start",
            //     "events": [
            //         PlotSteps.IdentifyWeakestUnit() // FOR SOME REASON, THIS IS GLITCHING OUT THE GAME, AND MAKING NOTHING THAT HAPPENS IN THE TURN:0:START BE RESPECTED??
            //     ]
            // },
            {
                "trigger": "turn:every-even:end",
                "events": [
                    PlotSteps.MoveEscapingUnits({"spotTag": "escape"}),
                ]
            },
            {
                "trigger": "turn:every-odd:start",
                "events": [
                    function ReleaseMonster() {
                        return (stage) => {
                            const amount = NUMBER_OF_MONSTERS[stage.turn.number] || 3
                            let spots = stage.random.shuffle(Object.values(stage.units).filter((unit) => {
                                return unit.spotTag == "warning"
                                    && Zone.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
                            }))

                            const spot = spots[0]
                            if(spots.length == 0) return

                            const enemies = Object.values(stage.units).filter((unit) => {
                                return unit.isDead != true
                                    && unit.isRemoved != true
                                    && unit.affiliation != stage.player.affiliation
                                    && Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position)
                            })
                            if(enemies.length > 10) return

                            const deadAllies = Object.values(stage.units).filter((unit) => {
                                return unit.isDead == true
                                    && (unit.key == "occultist" || unit.key == "professor" || unit.key == "priest")
                                    && unit.affiliation == stage.player.affiliation
                            })

                            const powerLevel = Number.parseInt(stage.currentEncounterKey)

                            return [
                                PlotSteps.PlayStinger("Unit:Monster:Spawn"),
                                ...spots.map((spot, index) => {
                                    if(index >= amount) return
                                    if(powerLevel == 3) {
                                        const deadAlly = deadAllies.pop()
                                        if(deadAlly != undefined) {
                                            return Step.deltastage({
                                                "unit": {
                                                    "key": deadAlly.key,
                                                    "name": deadAlly.name + "?",
                                                    "health": 20,
                                                    "isDead": false,
                                                    "affiliation": "bad",
                                                    "imageKey": "thrall-" + deadAlly.key,
                                                    "position": {
                                                        "x": spot.position.x,
                                                        "y": spot.position.y,
                                                        "z": spot.position.z,
                                                    }
                                                }
                                            })
                                        }
                                    }
                                    const weapon = stage.random.element(WEAPONS)
                                    return Step.deltastage({
                                        "unit": {
                                            "affiliation": "bad",

                                            "title": "???",
                                            "subtitle": "Monstrosity",

                                            "jobKey": weapon.jobKey,
                                            // "subtitle": weapon.subtitle,
                                            // "weaponImageKey": weapon.weaponImageKey,
                                            "weaponAudioKey": "Unit:Attack:Monster",
                                            "imageKey": "monster" + "-" + (powerLevel == 2 ? "tentacle" : "arms") + "-" + weapon.color,

                                            "maxhealth": powerLevel == 2 ? 30 : 20,

                                            "position": {
                                                "x": spot.position.x,
                                                "y": spot.position.y,
                                                "z": spot.position.z,
                                            },
                                        }
                                    })
                                }),
                                ...spots.map((spot) => {
                                    return Step.deltastage({
                                        "units": {[spot.key]: undefined}
                                    })
                                }),
                                PlotSteps.Wait(500),
                            ]
                        }
                    }
                ]
            },
            {
                "trigger": "turn:every-odd:end",
                "events": [
                    (stage) => {
                        if(stage.units["artist"].isDead == true) return
                        const events = [
                            PlotSteps.PlayStinger("Unit:Warning:Spawn"),
                        ]
                        for(let i = 0; i < NUMBER_OF_WARNINGS[stage.turn.number]; i += 1) {
                            events.push(PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn" + (stage.turn.number == 1 ? "-tutorial" : ""), "protounit": WARNING_SPOT}))
                        }
                        return events
                    }
                ]
            },
            {
                "condition": (stage) => {
                    return stage.currentEncounterKey == 1
                        && PlotConditions.hasEscaped(stage, {"affiliation": "good"})
                },
                "events": [
                    PlotSteps.ResetTutorialFlags(),
                    Step.flag("hud", "hidden"),
                    Step.flag("Cutscene", true),
                    Step.deltastage({"unit": {"key": "priest", "isRemoved": false}}),
                    Step.deltastage({"unit": {"key": "occultist", "isRemoved": false}}),
                    Step.deltastage({"unit": {"key": "professor", "isRemoved": false}}),
                    PlotSteps.PlayAudio("Music:Combat:2"),
                    PlotSteps.IdentifyWeakestUnit(),
                    PlotSteps.MovePlayerPartyToNewEncounter({"nextEncounterKey": 2, "spotTag": "enter", "turnNumber": 4, "isIgnoringEncounterBounds": true}),
                    PlotSteps.ifUnitIsAliveAndAllied("priest", "PRIEST: Th-There’s no end to them!"),
                    PlotSteps.ifUnitIsAliveAndAllied("professor", "PROFESSOR: We mustn’t panic. Keep your wits about you."),
                    PlotSteps.ifUnitIsAliveAndAllied("occultist", "OCCULTIST: They shan’t catch us if we run!"),
                    Step.flag("Cutscene", false),
                    Step.flag("hud", null),
                ]
            },
            {
                "condition": (stage) => {
                    return stage.currentEncounterKey == 2
                        && PlotConditions.hasEscaped(stage, {"affiliation": "good"})
                },
                "events": [
                    PlotSteps.ResetTutorialFlags(),

                    Step.flag("hud", "hidden"),
                    Step.flag("Cutscene", true),
                    Step.deltastage({"unit": {"key": "priest", "isRemoved": false}}),
                    Step.deltastage({"unit": {"key": "occultist", "isRemoved": false}}),
                    Step.deltastage({"unit": {"key": "professor", "isRemoved": false}}),
                    PlotSteps.MovePlayerPartyToNewEncounter({"nextEncounterKey": 3, "spotTag": "enter", "turnNumber": 2, "isIgnoringEncounterBounds": true}),

                    PlotSteps.KillAudio({"label": "music"}),
                    PlotSteps.ifUnitIsAliveAndAllied("priest", "PRIEST: Praise be – there, the exit!"),
                    PlotSteps.ifUnitIsAliveAndAllied("occultist", "OCCULTIST: Oh, thank goodness... my legs can’t run much farther."),
                    PlotSteps.ifUnitIsAliveAndAllied("professor", "PROFESSOR: Hold. I sense trouble."),

                    PlotSteps.PlayAudio("Tension:Closing"),
                    PlotSteps.Wait(500),
                    Step.deltastage({"camera": {"unitKey": "artist"}}),
                    PlotSteps.Wait(1000),
                    "ARTIST: Why, you thought I’d let you go without so much as a farewell? Such callous guests you are!  #position: 4",
                    Step.deltastage({"unit": {"key": "artist", "imageKey": "monster-host-smile", "portraitKey": "monster-host-smile"}}),
                    "ARTIST: Well, no matter. It shall not change your taste. #expression: smile #position: 4",
                    PlotSteps.Wait(200),
                    PlotSteps.PlayStinger("Scream2"),
                    PlotSteps.PlayAudio("Music:Combat:Boss"),
                    PlotSteps.Wait(800),
                    Step.deltastage({"unit": {"key": "artist", "imageKey": "monster-host-transformed", "portraitKey": "monster-host-transformed", "color": "#e9f2f5"}}),
                    PlotSteps.Wait(500),
                    "ARTIST: Bitter partings make for such wonderful dessert. #expression: transformed #position: 4",
                    PlotSteps.Wait(500),
                    // MUSIC KICKS IN
                    Step.deltastage({"camera": {"unitKey": null}}),
                    Step.deltastage({"unit": {"key": "artist", "imageKey": "monster-host-transformed-eyes"}}),
                    PlotSteps.Wait(100),
                    Step.deltastage({"unit": {"key": "artist", "properties": ["boss"]}}),
                    Step.flag("Cutscene", false),
                    Step.flag("hud", null),
                ]
            },
            {
                "condition": (stage) => {
                    return stage.currentEncounterKey == 3
                        && PlotConditions.hasEscaped(stage, {"affiliation": "good"})
                },
                "events": [
                    PlotSteps.ReportSuccessAnalytics(),
                    PlotSteps.KillAudio({"label": "music"}),
                    PlotSteps.KillAudio({"label": "ambience"}),
                    PlotSteps.PlayAudio("Chapter:Success"),
                    Step.flag("Cutscene", true),
                    PlotSteps.Wait(2000),
                    PlotSteps.BlackoutDialogue(`
                    In these darkest of rooms, this most bloody of nights
                    The feasting shall come to a close
                    And those who escape live to see one more day
                    For I am the most gracious of hosts
                    `),
                    (stage) => {
                        const steps = []
                        if(stage.units["occultist"].isDead != true
                        && stage.units["occultist"].affiliation == "good") {
                            steps.push(PlotSteps.MarkAchievement("ACH_OCCULTIST"))
                        }
                        if(stage.units["professor"].isDead != true
                        && stage.units["professor"].affiliation == "good") {
                            steps.push(PlotSteps.MarkAchievement("ACH_PROFESSOR"))
                        }
                        if(stage.units["priest"].isDead != true
                        && stage.units["priest"].affiliation == "good") {
                            steps.push(PlotSteps.MarkAchievement("ACH_PRIEST"))
                        }
                        return steps
                    },
                    PlotSteps.PlayAudio("Music:Title"),
                    {"func": () => Navigation.go("/games/feast/credits")},
                ]
            },
            {
                "condition": function(stage) {
                    // const remainingAlliedUnits = Object.values(stage.units).filter((unit) => {
                    //     return unit.affiliation == stage.player.affiliation
                    //         && unit.isDead != true
                    //         && Zone.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
                    // })
                    const alliedUnits = Object.values(stage.units).filter((unit) => {
                        return unit.affiliation == stage.player.affiliation
                            && unit.isDead != true
                    })
                    return alliedUnits.length == 0
                },
                "events": [
                    PlotSteps.ReportFailureAnalytics(),
                    Step.flag("Cutscene", true),
                    PlotSteps.PlayAudio("Chapter:Failure"),
                    PlotSteps.ChapterFailure(),
                    (stage) => {
                        if(stage.currentEncounterKey == 3) {
                            return PlotSteps.MarkAchievement("ACH_HOST")
                        }
                    },
                    PlotSteps.PlayAudio("Music:Title"),
                    {"func": () => Navigation.go("/games/feast/title")},
                ]
            },
        ]
    },
}



const WEAPONS = [
    {
        "jobKey": "hammer",
        "subtitle": "with an Axe",
        "weaponImageKey": "horror-axe",
        "color": "yellow",
    },
    {
        "jobKey": "sword",
        "subtitle": "with a Knife",
        "weaponImageKey": "horror-knife",
        "color": "red",
    },
    {
        "jobKey": "spear",
        "subtitle": "with a Shovel",
        "weaponImageKey": "horror-candelabra",
        // "weaponImageKey": "horror-shovel",
        "color": "blue",
    },
]

const WARNING_SPOT = {
    "name": "???",
    "jobName": "Something",
    "affiliation": "nothing",
    "moverange": 2,
    "attackrange": 1,
    "maxhealth": 10,
    "skillKeys": ["inflict-damage"],
    "properties": ["no healthbar"],
    "spotTag": "warning",
    "sprites": require("@frog/source/assets/images/horror-tactics/units/eyes2").default,
    "spriteSize": "contained",
}

const NUMBER_OF_WARNINGS = {
    1: 2,
    3: 2,
    5: 2,
    7: 3,
    9: 3,
    11: 3,
    13: 3,
    15: 3,
    17: 4,
}
const NUMBER_OF_MONSTERS = {
    3: 1,
    5: 1,
    7: 1,
    9: 2,
    11: 2,
    13: 2,
    15: 2,
    17: 2,
    19: 2,
    21: 2,
    23: 3,
}
